import printConfig from '../../../print-config.json'
import { Form, Formik } from 'formik';
import FormFlyerDataTabContainer from '../cont/FormFlyerDataTabContainer'
import { LEFT, MIDDLE, RIGHT } from '../../../constants/tabTypes';
import { generatePath } from 'react-router-dom';
import { PreviewButton } from './FlyerButtons';
import Translation from '../../Translation/cont/Translation';
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple';
import RequestOverlayContainer from '../../overlay/container/RequestOverlayContainer';

const EditFlyerContent = ({
    flyerServerData,
    activeWeek,
    hasChanges,
    cinemaId,
    printType,
    printFormat,
    printPk,
    landscape,
    basicUrl,
    closePagePath,
    side,
    printUpdateRequest,
    programStatus,
    programError
}) => {
    const currentSideName = side === 'outside' ? <Translation key="sec" id="print_flyer_outside"/> : side === 'inside' ? <Translation key="sec" id="print_flyer_inside"/> : ''
    const landscapeBoolean = landscape === "true"
    const outside = side === 'outside' 

    return (
        <WrapperPageSimple
            pageTitle={[<Translation key="name_one" id={printConfig.routes[printType].transIdname} after={' / '}/>,<Translation key="name_two" id="print_cw" after={' ' + activeWeek + ' / '}/>, currentSideName]} 
            closePagePath={closePagePath}
            overlay={
                <RequestOverlayContainer
                    programStatus={programStatus} 
                    programError={programError}
                />
            }
        >
            <div className="program-page program-page-sorting-movies flyer flyer-edit print-page site-content">
                <Formik
                    initialValues={flyerServerData}
                    enableReinitialize
                    // onSubmit={(values, actions) => {
                    // }}
                    // onReset={(values, actions) => {
                    //     history.push(closePagePath)
                    // }}
                    >
                    {({values}) => (
                        <Form>
                            <FormFlyerDataTabContainer
                                side={side}
                                values={values}
                                cinemaId={cinemaId}
                                printType={printType}
                                printFormat={printFormat}
                                landscape={landscapeBoolean}
                                activeWeek={activeWeek}
                                printPk={printPk}
                                basicUrl={basicUrl}
                                tabs={
                                    [
                                        {
                                            "title": outside ? <Translation id="print_flyer_page_1"/> : <Translation id="print_flyer_inside_left"/>,
                                            "id": LEFT
                                        },
                                        {
                                            "title": outside ? <Translation id="print_flyer_back_u4"/> : <Translation id="print_flyer_inside_middle"/>,
                                            "id": MIDDLE
                                        },
                                        {
                                            "title": outside ? <Translation id="print_flyer_title_u1"/> : <Translation id="print_flyer_inside_right"/>,
                                            "id": RIGHT
                                        }
                                    ]
                                }
                            />
                        </Form>
                    )}
                </Formik>

                <div className="save-program-button save-button-wrapper">
                    <PreviewButton
                        hasChanges={hasChanges}
                        cinemaId={cinemaId}
                        printType={printType}
                        printID={printFormat}
                        printPk={printPk}
                        landscapeBoolean={landscapeBoolean}
                        printUpdateRequest={printUpdateRequest}
                        activeWeek={activeWeek}
                    />
                </div>

            </div>
        </WrapperPageSimple>
    )
}

export default EditFlyerContent

